// extracted by mini-css-extract-plugin
export var buttons = "_b2-0";
export var buttonsActive = "_b2-h";
export var cancelConfirm = "_b2-1";
export var closeButton = "_b2-2";
export var column = "_b2-3";
export var container = "_b2-4";
export var detailHeader = "_b2-6";
export var detailTitle = "_b2-7";
export var detailsContent = "_b2-5";
export var header = "_b2-8";
export var headerWithClose = "_b2-9";
export var icon = "_b2-a";
export var infoIcon = "_b2-c";
export var informationContainer = "_b2-b";
export var sideDrawer = "_b2-d";
export var sideDrawerOpen = "_b2-e";
export var stickyFooter = "_b2-f";
export var typeOption = "_b2-g";